












































































import Vue from 'vue'
import store from '@/store'
import { WorksItem, formatWorksItem, getWorksImageSrc, getWorksVideoSrc } from '@/types/works'

const WP_SITE_URL = process.env.NODE_ENV === 'development'
  ? process.env.VUE_APP_DEV_WP_SITE_URL
  : process.env.VUE_APP_PRO_WP_SITE_URL

export default Vue.extend({
  data() {
    return {
      work: null as WorksItem | null,
      relatedWorks: [],
      loading: true
    }
  },

  async created() {
    await this.fetchWork()
  },

  watch: {
    '$route': 'fetchWork'
  },

  methods: {
    getImageSrc(image: any): string {
      return getWorksImageSrc(image)
    },

    getVideoSrc(video: any): string {
      return getWorksVideoSrc(video)
    },

    async fetchWork() {
      this.loading = true
      const id = this.$route.params.id
      const isPreview = this.$route.query.preview === 'true'

      try {
        const query = new URLSearchParams({
          _embed: '1',
          acf_format: 'standard',
          status: isPreview ? 'draft' : 'public'
        })

        const response = await fetch(`${WP_SITE_URL}/wp-json/wp/v2/works/${id}?${query}`, {
          headers: isPreview && typeof this.$route.query.nonce === 'string'
            ? { 'X-WP-Nonce': this.$route.query.nonce }
            : undefined
        })
        const post = await response.json()
        this.work = formatWorksItem(post)

        console.log(this.work)
        
        this.relatedWorks = post.related_works.map(item => {
          return {
            id: item.ID,
            thumbnailUrl: item.thumbnail,
            title: item.post_title
          }
        })
      } catch (error) {
        console.error(error)
        this.work = null
      } finally {
        this.loading = false
      }
    }
  }
})
